export default "__VITE_ASSET__ofw69SEZ__"